import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { SaveUserAddressInfoinAllApplications, zipAndBranchDetail } from '../../../AdminActionCreator.component';

const permanentResidenceTypeData = [
    { value: 'Rented', label: 'Rented' },
    { value: 'Own', label: 'Own' },
]


const textFieldData = [
    { label: "Address Type", value: "permanentResidenceType", placeholder: "Enter Address Type", type: "text", name: "permanentResidenceType" },
    { label: "Rented Amount (if Rented)", value: "permanentMonthlyRent", placeholder: "Enter Rented Amount", type: "number", name: "permanentMonthlyRent" },
    { label: "Duration", value: "permanentResidenceValue", placeholder: "Enter Duration", type: "number", name: "permanentResidenceValue" },
    { label: "Pincode", value: "permanentPincode", placeholder: "Enter Pincode", type: "text", name: "permanentPincode" },
    { label: "Permanent Address", value: "permanentAddress", placeholder: "Enter Permanent Address", type: "text", name: "permanentAddress" },
    { label: "Permanent Town", value: "permanentTown", placeholder: "Enter permanentTown", type: "text", name: "permanentTown" },
    { label: "Permanent City", value: "permanentCity", placeholder: "Enter Permanent City", type: "text", name: "permanentCity" },
    { label: "Permanent Landmark", value: "permanentLandmark", placeholder: "Enter Permanent Landmark", type: "text", name: "permanentLandmark" },
    { label: "Permanent District", value: "permanentDistrict", placeholder: "Enter Permanent District", type: "text", name: "permanentDistrict" },
    { label: "Permanent State", value: "permanentState", placeholder: "Enter Permanent State", type: "text", name: "permanentState" },
]

export default function EditPersonalDetail({ data, closePopup, customStyle, handleLoader, handleTextPopup, closeTextPopup, admin }) {
    const [objectData, setObjectData] = useState({
        "permanentResidenceType": "",
        "permanentMonthlyRent": "",
        "permanentResidenceValue": "",
        "permanentPincode": "",
        "permanentAddress": "",
        "permanentTown": "",
        "permanentCity": "",
        "permanentLandmark": "",
        "permanentDistrict": "",
        "permanentState": "",
    });

    const handleInputValues = (e) => {
        const { name, value } = e.target;

        if (name == "permanentPincode" && e.target.value?.length == 6) {
                handlezipAndBranchDetailFn(e.target.value)
        }

        setObjectData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useEffect(() => {
        console.log("data", data)
        if (data?.userId) {
            setObjectData({
                "permanentResidenceType": data?.addressDetailsPO?.permanentResidenceType || "",
                "permanentMonthlyRent": data?.addressDetailsPO?.permanentMonthlyRent || "",
                "permanentResidenceValue": data?.addressDetailsPO?.permanentStayDuration || "",
                "permanentPincode": data?.addressDetailsPO?.permanentPincode || "",
                "permanentAddress": data?.addressDetailsPO?.permanentAddress || "",
                "permanentTown": data?.addressDetailsPO?.permanentTown || "",
                "permanentCity": data?.addressDetailsPO?.permanentCity || "",
                "permanentLandmark": data?.addressDetailsPO?.permanentLandmark || "",
                "permanentDistrict": data?.addressDetailsPO?.permanentDistrict || "",
                "permanentState": data?.addressDetailsPO?.permanentState || "",
            })
        } else {
            setObjectData({
                "permanentResidenceType": "",
                "permanentMonthlyRent": "",
                "permanentResidenceValue": "",
                "permanentPincode": "",
                "permanentAddress": "",
                "permanentTown": "",
                "permanentCity": "",
                "permanentLandmark": "",
                "permanentDistrict": "",
                "permanentState": "",
            })
        }
    }, [])


    const handleSave = () => {
        const obj = { ...objectData, userId: data?.userId,
            "formStatus":"update",
              "empId":admin?.emailId
         }
        handleLoader(true)
        SaveUserAddressInfoinAllApplications(obj, callback => {
            if (callback?.message == "success" && callback?.status == 200) {
                handleTextPopup(true, "Permanent Address Information Updated Successfully")
            } else {
                handleTextPopup(true, "Error Updating Permanent Address Information")
            }
            handleLoader(false)
            closeTextPopup()
        })
    }

    const handlezipAndBranchDetailFn = (value) => {
        handleLoader(true)
        zipAndBranchDetail(value, 'zip', res => {
            handleLoader(false)
            if (res.status === 'success') {
                setObjectData((prev)=>({
                    ...prev,
                    permanentCity: res.city,
                    permanentDistrict: res.destrict,
                    permanentState: res.state,
                }))
            }
        })
    }


    return (
        <>
            <div className='background-blur income' style={customStyle}>
                <div className='popup-main small-popup container-fluid dbl-border'>
                    <button className='close' onClick={e => closePopup()}>
                        &times;
                    </button>
                    <h4 style={{ color: '#000' }}>Edit Permanent Address Details</h4>

                    <div className="row">
                        {
                            textFieldData && textFieldData?.map((value, index) => {
                                return (
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>

                                        {
                                            value?.name !== "permanentResidenceType" ?

                                                <TextField fullWidth id="outlined-basic" label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]}
                                                    placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} />
                                                :
                                                value?.name == "permanentResidenceType" ?
                                                    <TextField fullWidth id="outlined-basic" select label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]} placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} >
                                                        {permanentResidenceTypeData?.map((option) => (
                                                            <MenuItem key={option.value} value={option.label}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                    :
                                                    ""
                                        }

                                    </div>
                                )
                            })
                        }

                        <div className="col-xs-12" style={{ marginTop: '20px', textAlign: 'center' }}>
                            <button className='btn btn-primary' onClick={() => handleSave()}>Save</button>
                        </div>
                    </div>

                </div>


            </div >
        </>
    )
}
